/**
 * AI Agent 环境服务
 * @description 提供 AI Agent 环境相关的服务, 比如是否在 AI Agent 流程中
 */
export interface AiAgentEnvService {
    /**
     * 是否在 AI Agent 流程中
     */
    readonly isInAiAgentFlow: boolean;
    /**
     * 是否在 iframe 中
     */
    readonly isInIframe: boolean;
    /**
     * 获取 iframe 的 window 对象
     */
    readonly win: Window;
}

export const AiAgentEnvService = Symbol('AiAgentEnvService');
